import { CONFIG_SWIPER, CONFIG_SWIPER_DEFAULT } from './config';

export const getSwiperConfig = () => {
  if (typeof window === 'undefined' || window.matchMedia == null) return CONFIG_SWIPER_DEFAULT;
  return CONFIG_SWIPER.find(({ mq }) => window.matchMedia(mq).matches) ?? CONFIG_SWIPER_DEFAULT;
};
